import React from 'react'
import { OnboardingsTableFields, OnboardingStatus } from './enums'

export const ONBOARDING_STATUSES_WITH_DELAYED_INFO = [
  OnboardingStatus.Created,
  OnboardingStatus.WaitingForApproval,
  OnboardingStatus.Failed,
  OnboardingStatus.PartiallyCompleted,
]

export const onboardingStatusTitle = {
  [OnboardingStatus.Created]: 'Invited contractors',
  [OnboardingStatus.WaitingForApproval]: 'Waiting for approval',
  [OnboardingStatus.Completed]: 'Onboarded contractors',
  [OnboardingStatus.Failed]: 'Onboarding failed',
  [OnboardingStatus.PartiallyCompleted]: 'Partially Completed',
}

export const onboardingTableHeaderTitles: { [key in OnboardingsTableFields]: string } = {
  [OnboardingsTableFields.contractorId]: 'Contractors ID',
  [OnboardingsTableFields.contractorName]: 'Name',
  [OnboardingsTableFields.contractorType]: 'Type',
  [OnboardingsTableFields.phone]: 'Phone number',
  [OnboardingsTableFields.tags]: 'Tag(s)',
  [OnboardingsTableFields.onboardingFlow]: 'Assigned Template',
  [OnboardingsTableFields.invitedAt]: 'Invited at',
  [OnboardingsTableFields.toReviewCount]: 'Needs review',
  [OnboardingsTableFields.stepsCompleted]: 'Steps completed',
  [OnboardingsTableFields.isActive]: 'Active',
  [OnboardingsTableFields.email]: 'Email',
  [OnboardingsTableFields.dateOnboarded]: 'Date onboarded',
  [OnboardingsTableFields.actions]: 'Actions',
  [OnboardingsTableFields.status]: 'Status',
  [OnboardingsTableFields.failedAt]: 'Failure Date',
  [OnboardingsTableFields.failureReason]: 'Failure reason',
}
